import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false // NOSONAR
})
export class AppComponent {
  title = 'lios-aet-mfe';  
  
  hideFooter: boolean = false;

 

  constructor( private readonly router : Router) {}

 

  ngOnInit() { // NOSONAR
    const e = document.getElementById('footerheight')?.offsetHeight;
    const h = document.getElementById('headerHeight')?.offsetHeight;
    const t = document.getElementById('toolbarheight')?.offsetHeight;
    localStorage.setItem('footerheight',e.toString())
    localStorage.setItem('headerHeight',h.toString())
    localStorage.setItem('toolbarheight',t.toString())
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if(event instanceof NavigationEnd)
         { this.hideFooter = event.url.includes('/kpi');}
      });
  }
  ngAfterViewInit(){ // NOSONAR
    const t = document.getElementById('toolbarheight')?.offsetHeight;
    console.info('In app',t);
  }
}
